(function() {
  // --- Keep the sticky cart's Loox rating scoped to the current product ---
  function formatStickyCartReviews() {
    const reviewContainer = document.querySelector('.satcb_reviews_stars');
    if (!reviewContainer) return;

    // The sticky-cart app sometimes leaves its rating container empty even after
    // Loox has rendered a valid rating beside the current product. Mirror that
    // current-product rating into the bar; never source it from recommendation cards.
    let hasRatingContent = Boolean(reviewContainer.querySelector('.loox-rating-content'));
    const productRatingContent = document.querySelector('.product--outer .loox-rating-content');

    if (!hasRatingContent && productRatingContent) {
      const stickyRating = document.createElement('div');
      stickyRating.className = 'loox-rating satcb-loox-rating';
      stickyRating.appendChild(productRatingContent.cloneNode(true));
      reviewContainer.replaceChildren(stickyRating);
      hasRatingContent = true;
    }

    // When the current product has no reviews, the sticky-cart app can fall back to
    // every Loox star SVG on the page (including related-product cards). Those
    // incorrect stars are direct children; a real product rating is wrapped in
    // .loox-rating-content.
    const hasDirectStars = Array.from(reviewContainer.children)
      .some((child) => child.matches('svg.loox-icon'));

    if (hasDirectStars && !hasRatingContent) {
      reviewContainer.replaceChildren();
      reviewContainer.style.setProperty('display', 'none', 'important');
      reviewContainer.dataset.looxInvalidFallback = 'true';
      return;
    }

    if (!hasRatingContent) return;

    // Restore the container now that a genuine current-product rating is present,
    // then wrap just the count so CSS can hide it on mobile.
    reviewContainer.style.removeProperty('display');
    delete reviewContainer.dataset.looxInvalidFallback;

    const ratingLabel = reviewContainer.querySelector('.loox-rating-label');
    if (!ratingLabel || ratingLabel.querySelector('.satcb-review-count')) return;

    const labelText = ratingLabel.textContent.replace(/\u00a0/g, ' ').trim();
    const labelParts = labelText.match(/^(.+?)\s*(\([^)]*\))$/);
    if (labelParts) {
      const count = document.createElement('span');
      count.className = 'satcb-review-count';
      count.textContent = ` ${labelParts[2]}`;
      ratingLabel.replaceChildren(
        document.createTextNode(`\u00a0${labelParts[1].trim()}`),
        count
      );
    }
  }

  // --- Currency setup ---
  const removableSuffixes   = ['AUD','CAD','NZD','EUR','GBP','USD'];
  const suffixToPrefixMap   = { AUD:'A$', CAD:'C$', NZD:'NZ$', USD:'$', EUR:'€', GBP:'£' };
  const containersSelector = [
    '.price__current', '.satcb_price', '.satcb_was_price', '.cart-item--sale-price',
    '.atc-subtotal--price', '.atc--product-details--price-value',
    '.cart-item--content-price', '.cart-item__total',
    '.cart-subtotal', '.atc-banner--cart-subtotal',
    '.cart-title-total--small',
    '.cart-complementary__price-row',
    '.options-selection__swatch-card-price',
    '.savings',
    '.voucher-amount',
    '.complementary-product__price'
  ].join(',');

  // This function takes raw text and returns formatted HTML
  function getFormattedPriceHTML(rawText) {
    let cleaned = rawText.trim();
    let overrideCur = null;
    const sufMatch = cleaned.match(/([\d.,]+)\s*([A-Z]{3})$/);
    if (sufMatch && removableSuffixes.includes(sufMatch[2])) {
      cleaned = cleaned.replace(/\s*[A-Z]{3}$/,'');
      overrideCur = suffixToPrefixMap[sufMatch[2]];
    }

    const symMatch = cleaned.match(/^(C\$|NZ\$|A\$|\$|€|£)/);
    let symbol = overrideCur || (symMatch ? symMatch[1] : null);
    if (!symbol) return null;
    if (!overrideCur && symbol === '$' && typeof Shopify !== 'undefined' && Shopify.currency) symbol = suffixToPrefixMap[Shopify.currency.active] || symbol;
    if (symbol === 'NZ$') symbol = '$';
    let numPart = cleaned.replace(/^(C\$|NZ\$|A\$|\$|€|£)/,'').trim();
    const numTokens = numPart.match(/(?:\d{1,3}(?:[., ]\d{3})+|\d+)(?:[.,]\d{1,2})?/g);
    if (numTokens && numTokens.length) numPart = numTokens[numTokens.length - 1];
    numPart = numPart.replace(/\s/g, '');
    const commaAsDec = numPart.lastIndexOf(',') === numPart.length - 3;
    if (commaAsDec) {
      numPart = numPart.replace(/\./g,'').replace(',','.');
    } else {
      numPart = numPart.replace(/,/g,'');
    }

    const m = numPart.match(/^(\d+)\.(\d{2})$/);
    if (!m) return null; // Return null if format is not recognized
    const [ , whole, frac ] = m;

    let symbolHTML;
    if (['C$', 'A$', 'NZ$'].includes(symbol)) {
      const letter = symbol.slice(0, -1);
      const dollar = symbol.slice(-1);
      symbolHTML = `<span style="font-size: .7em !important; vertical-align: top !important; position: relative !important; top: 2px !important; padding-right: 2px !important;">${letter}</span><span>${dollar}</span>`;
    } else {
      symbolHTML = symbol;
    }

    return `<span class="satcb_price_inner" data-shopsta-price>` +
           `<span class="price-symbol">${symbolHTML}</span>` +
           `<span class="price-whole">${whole}</span>` +
           `<span class="shopsta-price-decimal">.</span><span class="price-fraction">${frac}</span>` +
           `</span>`;
  }

  // Build the final price before a variant update touches the live DOM.
  window.ShopstaPrices = {
    html(raw) {
      const source = document.createElement('span');
      source.innerHTML = raw;
      return getFormattedPriceHTML(source.textContent) || raw;
    }
  };

  function formatPrices() {
    document.querySelectorAll(containersSelector).forEach(container => {
      // Note: .satcb_price / .satcb_was_price used to be delegated to handleSatcbPrice()
      // via a sibling-display hack, but newer SATCB layouts put the .money class on the
      // .satcb_price container itself (no nested .money child), which broke that handler.
      // Format here directly — the self-healing .price-symbol check on every observer
      // tick reformats if SATCB ever overwrites the contents (e.g. on variant change).
      let els = container.querySelectorAll('.money');
      if (!els.length && (container.classList.contains('money') || container.classList.contains('savings') || container.classList.contains('voucher-amount'))) els = [container];

      els.forEach(el => {
        // Trust the DOM, not a dataset flag — see UK ratings-replace.js for the full
        // rationale. Self-heals if any other script (currency switcher, app price updater,
        // cart drawer rerender) clobbers our .money innerHTML back to raw text.
        if (el.querySelector('.satcb_price_inner')) return;
        const formattedHTML = getFormattedPriceHTML(el.textContent.trim());
        if (formattedHTML) {
          el.innerHTML = formattedHTML;
        }
      });
    });
  }

  function handleSatcbPrice() {
    const satcbPriceContainer = document.querySelector('.satcb_price, .satcb_was_price');
    if (!satcbPriceContainer) return;

    const originalPriceEl = satcbPriceContainer.querySelector('.money');
    if (!originalPriceEl) return;

    // Find or create our custom display element
    let customDisplay = satcbPriceContainer.querySelector('.custom-formatted-price');
    if (!customDisplay) {
      customDisplay = document.createElement('div');
      customDisplay.className = 'custom-formatted-price';
      originalPriceEl.parentNode.insertBefore(customDisplay, originalPriceEl.nextSibling);
      
      // Hide the original element permanently
      originalPriceEl.style.display = 'none';
    }

    const rawText = originalPriceEl.textContent.trim();
    const formattedHTML = getFormattedPriceHTML(rawText);
    
    // Update our custom element, leaving the original hidden one alone
    // innerHTML normalizes boolean attributes, so comparing it with an HTML
    // string would repeatedly rewrite the same price in the mutation observer.
    if (formattedHTML && (customDisplay.dataset.priceRaw !== rawText || !customDisplay.querySelector('[data-shopsta-price]'))) {
      customDisplay.innerHTML = formattedHTML;
      customDisplay.dataset.priceRaw = rawText;
    }
  }

  function stripNZ() {
    var els = document.querySelectorAll('.money');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.childElementCount > 0) continue;
      var t = el.textContent;
      if (t.indexOf('NZ$') !== -1) el.textContent = t.replace(/NZ\$/g, '$');
    }
  }

  // --- Observer to handle dynamic SATCB price changes ---
  function initialize() {
  const observer = new MutationObserver((mutations) => {
    const relevantSelector = `${containersSelector}, .money, .satcb_reviews_stars, .loox-rating-content`;
    const relevant = mutations.some(mutation => {
      const target = mutation.target.nodeType === Node.ELEMENT_NODE
        ? mutation.target
        : mutation.target.parentElement;
      if (target && target.closest(relevantSelector)) return true;
      return Array.from(mutation.addedNodes).some(node =>
        node.nodeType === Node.ELEMENT_NODE &&
        (node.matches(relevantSelector) || node.querySelector(relevantSelector))
      );
    });
    // Delivered mutation batches run before paint, including app price rewrites.
    if (relevant) {
      handleSatcbPrice();
      formatPrices();
      stripNZ();
      formatStickyCartReviews();
    }
  });

  // --- Initial run and start observing ---

  formatStickyCartReviews();
  formatPrices();
  stripNZ();
  handleSatcbPrice(); // Initial setup for the SATCB bar

  observer.observe(document.body, { 
    childList: true, 
    subtree: true,
    characterData: true // Important for detecting text changes
  });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
})();
